import css from './Portfolio.module.scss'
// import SectionTitle from "../../SectionTitle";
// import SectionSubTitle from "../../SectionSubTitle";
import PortfolioCard from "./PortfolioCard";
import {works} from "../../config/data"
import Title from "../Title";


const Portfolio = (props) => {
  return (
      <>
        <div id={css.portfolio} className={'px-5'}>
          <Title title={'Works'}/>
          {works && works.map((work, i) => (
              <PortfolioCard work={work} index={i} key={i} total={works.length}></PortfolioCard>
          ))}
        </div>
      </>
  );
}

export default Portfolio;
